import React from 'react';
import { withRouter } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { getUser, removeUserSession } from './utils/UserDetails';

const AuthVerify = (props) => {
  props.history.listen(() => {
    const user = getUser();

    if (user) {
      const { exp } = jwtDecode(user);

      if (exp * 1000 < Date.now()) {
        removeUserSession();
      }
    } else {
      removeUserSession();
    }
  });

  return <div></div>;
};

export default withRouter(AuthVerify);
